<script setup>
import { Head } from '@inertiajs/vue3'
import { isProduction } from '@js/App/Utils/Environment'
import HeadMetaAlternate from '@js/Components/Meta/HeadMetaAlternate.vue'
import HeadMetaCanonical from '@js/Components/Meta/HeadMetaCanonical.vue'
import RentbirdPlusTopBar from '@js/Components/TopBars/RentbirdPlusTopBar.vue'
</script>

<template>
  <Head>
    <meta head-key="description" name="description" :content="$trans('Layout.MetaDescription')">
    <meta v-if="!isProduction()" name="robots" content="noindex, nofollow">
  </Head>
  <RentbirdPlusTopBar />
  <HeadMetaCanonical />
  <HeadMetaAlternate />
  <slot />
</template>
